<script>
export default {
    name: "Games"
}
</script>

<template>
<section class="games slide-up" >
    <h2>{{__('Моды для этих игр уже в нашем приложении')}}</h2>
    <div class="games-wrapper">
        <div class="game-card-container">
            <img src="@/assets/images/games/gta5.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Grand Theft Auto V</div>
                <div class="game-card-total-mods">200+ {{__('модификаций')}}</div>
            </div>
            <div class="game-card-benefit">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3.57349C12 3.07031 11.5917 2.66236 11.0885 2.66236C10.585 2.66236 10.1766 3.07031 10.1766 3.57349C10.1766 3.81959 10.2744 4.04262 10.433 4.20631C9.813 5.49023 8.62793 5.93848 7.70948 5.53273C6.89137 5.1709 6.58962 4.13672 6.48743 3.33546C6.82104 3.16006 7.04848 2.81067 7.04848 2.40748C7.04845 1.8285 6.57935 1.35938 6 1.35938C5.42102 1.35938 4.95155 1.8285 4.95155 2.40748C4.95155 2.81067 5.17896 3.16003 5.51259 3.33546C5.41043 4.13674 5.10867 5.17092 4.29054 5.53273C3.37207 5.9385 2.18702 5.49023 1.56703 4.20631C1.72561 4.04262 1.82339 3.81959 1.82339 3.57349C1.82339 3.07031 1.41506 2.66236 0.911883 2.66236C0.408328 2.66236 0 3.07031 0 3.57349C0 4.03711 0.34643 4.41907 0.793945 4.47694L1.8446 8.32252H10.1554L11.2061 4.47694C11.6539 4.41907 12 4.03711 12 3.57349Z" fill="#FFD15C"/>
                    <path d="M10.6644 9.96242C10.6644 10.337 10.3609 10.6407 9.98585 10.6407H2.01417C1.63952 10.6406 1.33594 10.337 1.33594 9.96242V9.90603C1.33594 9.53103 1.63952 9.22744 2.01417 9.22744H9.98585C10.3609 9.22744 10.6644 9.53103 10.6644 9.90603V9.96242Z" fill="#FFD15C"/>
                </svg>
                {{__('Самая популярная')}}
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/minecraft.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Minecraft</div>
                <div class="game-card-total-mods">30000+ {{__('модификаций')}}</div>
            </div>
            <div class="game-card-benefit">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_369_72)">
                    <path d="M10.672 4.917C10.546 4.661 10.285 4.5 10 4.5H6.854L7.328 0.845997C7.371 0.509997 7.183 0.184997 6.869 0.0559965C6.555 -0.0730035 6.193 0.0239965 5.988 0.293997L1.404 6.295C1.23 6.522 1.201 6.827 1.328 7.083C1.454 7.339 1.715 7.5 2 7.5H5.146L4.672 11.154C4.629 11.49 4.817 11.815 5.131 11.944C5.224 11.982 5.32 12.001 5.416 12.001C5.645 12.001 5.867 11.897 6.012 11.706L10.595 5.706C10.769 5.479 10.798 5.174 10.671 4.918L10.672 4.917Z" fill="#FFD15C"/>
                </g>
                <defs>
                    <clipPath id="clip0_369_72">
                        <rect width="12" height="12" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
                {{__('Больше всего модов')}}
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/ets2.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">ETS 2</div>
                <div class="game-card-total-mods">200+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/beamng.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">BeamNG.drive</div>
                <div class="game-card-total-mods">500+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/sims4.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">The Sims 4</div>
                <div class="game-card-total-mods">2500+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/terraria.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Terraria</div>
                <div class="game-card-total-mods">150+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/wukong.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Black Myth: Wukong</div>
                <div class="game-card-total-mods">50+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/stardew.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Stardew Valley</div>
                <div class="game-card-total-mods">850+ {{__('модификаций')}}</div>
            </div>
        </div>

        <div class="game-card-container">
            <img src="@/assets/images/games/gta5.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Grand Theft Auto V</div>
                <div class="game-card-total-mods">200+ {{__('модификаций')}}</div>
            </div>
            <div class="game-card-benefit">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3.57349C12 3.07031 11.5917 2.66236 11.0885 2.66236C10.585 2.66236 10.1766 3.07031 10.1766 3.57349C10.1766 3.81959 10.2744 4.04262 10.433 4.20631C9.813 5.49023 8.62793 5.93848 7.70948 5.53273C6.89137 5.1709 6.58962 4.13672 6.48743 3.33546C6.82104 3.16006 7.04848 2.81067 7.04848 2.40748C7.04845 1.8285 6.57935 1.35938 6 1.35938C5.42102 1.35938 4.95155 1.8285 4.95155 2.40748C4.95155 2.81067 5.17896 3.16003 5.51259 3.33546C5.41043 4.13674 5.10867 5.17092 4.29054 5.53273C3.37207 5.9385 2.18702 5.49023 1.56703 4.20631C1.72561 4.04262 1.82339 3.81959 1.82339 3.57349C1.82339 3.07031 1.41506 2.66236 0.911883 2.66236C0.408328 2.66236 0 3.07031 0 3.57349C0 4.03711 0.34643 4.41907 0.793945 4.47694L1.8446 8.32252H10.1554L11.2061 4.47694C11.6539 4.41907 12 4.03711 12 3.57349Z" fill="#FFD15C"/>
                    <path d="M10.6644 9.96242C10.6644 10.337 10.3609 10.6407 9.98585 10.6407H2.01417C1.63952 10.6406 1.33594 10.337 1.33594 9.96242V9.90603C1.33594 9.53103 1.63952 9.22744 2.01417 9.22744H9.98585C10.3609 9.22744 10.6644 9.53103 10.6644 9.90603V9.96242Z" fill="#FFD15C"/>
                </svg>
                {{__('Самая популярная')}}
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/minecraft.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Minecraft</div>
                <div class="game-card-total-mods">30000+ {{__('модификаций')}}</div>
            </div>
            <div class="game-card-benefit">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_369_72)">
                        <path d="M10.672 4.917C10.546 4.661 10.285 4.5 10 4.5H6.854L7.328 0.845997C7.371 0.509997 7.183 0.184997 6.869 0.0559965C6.555 -0.0730035 6.193 0.0239965 5.988 0.293997L1.404 6.295C1.23 6.522 1.201 6.827 1.328 7.083C1.454 7.339 1.715 7.5 2 7.5H5.146L4.672 11.154C4.629 11.49 4.817 11.815 5.131 11.944C5.224 11.982 5.32 12.001 5.416 12.001C5.645 12.001 5.867 11.897 6.012 11.706L10.595 5.706C10.769 5.479 10.798 5.174 10.671 4.918L10.672 4.917Z" fill="#FFD15C"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_369_72">
                            <rect width="12" height="12" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                {{__('Больше всего модов')}}
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/ets2.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">ETS 2</div>
                <div class="game-card-total-mods">200+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/beamng.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">BeamNG.drive</div>
                <div class="game-card-total-mods">500+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/sims4.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">The Sims 4</div>
                <div class="game-card-total-mods">2500+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/terraria.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Terraria</div>
                <div class="game-card-total-mods">150+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/wukong.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Black Myth: Wukong</div>
                <div class="game-card-total-mods">50+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/stardew.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Stardew Valley</div>
                <div class="game-card-total-mods">850+ {{__('модификаций')}}</div>
            </div>
        </div>

        <div class="game-card-container">
            <img src="@/assets/images/games/gta5.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Grand Theft Auto V</div>
                <div class="game-card-total-mods">200+ {{__('модификаций')}}</div>
            </div>
            <div class="game-card-benefit">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3.57349C12 3.07031 11.5917 2.66236 11.0885 2.66236C10.585 2.66236 10.1766 3.07031 10.1766 3.57349C10.1766 3.81959 10.2744 4.04262 10.433 4.20631C9.813 5.49023 8.62793 5.93848 7.70948 5.53273C6.89137 5.1709 6.58962 4.13672 6.48743 3.33546C6.82104 3.16006 7.04848 2.81067 7.04848 2.40748C7.04845 1.8285 6.57935 1.35938 6 1.35938C5.42102 1.35938 4.95155 1.8285 4.95155 2.40748C4.95155 2.81067 5.17896 3.16003 5.51259 3.33546C5.41043 4.13674 5.10867 5.17092 4.29054 5.53273C3.37207 5.9385 2.18702 5.49023 1.56703 4.20631C1.72561 4.04262 1.82339 3.81959 1.82339 3.57349C1.82339 3.07031 1.41506 2.66236 0.911883 2.66236C0.408328 2.66236 0 3.07031 0 3.57349C0 4.03711 0.34643 4.41907 0.793945 4.47694L1.8446 8.32252H10.1554L11.2061 4.47694C11.6539 4.41907 12 4.03711 12 3.57349Z" fill="#FFD15C"/>
                    <path d="M10.6644 9.96242C10.6644 10.337 10.3609 10.6407 9.98585 10.6407H2.01417C1.63952 10.6406 1.33594 10.337 1.33594 9.96242V9.90603C1.33594 9.53103 1.63952 9.22744 2.01417 9.22744H9.98585C10.3609 9.22744 10.6644 9.53103 10.6644 9.90603V9.96242Z" fill="#FFD15C"/>
                </svg>
                {{__('Самая популярная')}}
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/minecraft.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Minecraft</div>
                <div class="game-card-total-mods">30000+ {{__('модификаций')}}</div>
            </div>
            <div class="game-card-benefit">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_369_72)">
                        <path d="M10.672 4.917C10.546 4.661 10.285 4.5 10 4.5H6.854L7.328 0.845997C7.371 0.509997 7.183 0.184997 6.869 0.0559965C6.555 -0.0730035 6.193 0.0239965 5.988 0.293997L1.404 6.295C1.23 6.522 1.201 6.827 1.328 7.083C1.454 7.339 1.715 7.5 2 7.5H5.146L4.672 11.154C4.629 11.49 4.817 11.815 5.131 11.944C5.224 11.982 5.32 12.001 5.416 12.001C5.645 12.001 5.867 11.897 6.012 11.706L10.595 5.706C10.769 5.479 10.798 5.174 10.671 4.918L10.672 4.917Z" fill="#FFD15C"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_369_72">
                            <rect width="12" height="12" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                {{__('Больше всего модов')}}
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/ets2.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">ETS 2</div>
                <div class="game-card-total-mods">200+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/beamng.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">BeamNG.drive</div>
                <div class="game-card-total-mods">500+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/sims4.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">The Sims 4</div>
                <div class="game-card-total-mods">2500+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/terraria.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Terraria</div>
                <div class="game-card-total-mods">150+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/wukong.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Black Myth: Wukong</div>
                <div class="game-card-total-mods">50+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/stardew.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Stardew Valley</div>
                <div class="game-card-total-mods">850+ {{__('модификаций')}}</div>
            </div>
        </div>

        <div class="game-card-container">
            <img src="@/assets/images/games/gta5.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Grand Theft Auto V</div>
                <div class="game-card-total-mods">200+ {{__('модификаций')}}</div>
            </div>
            <div class="game-card-benefit">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3.57349C12 3.07031 11.5917 2.66236 11.0885 2.66236C10.585 2.66236 10.1766 3.07031 10.1766 3.57349C10.1766 3.81959 10.2744 4.04262 10.433 4.20631C9.813 5.49023 8.62793 5.93848 7.70948 5.53273C6.89137 5.1709 6.58962 4.13672 6.48743 3.33546C6.82104 3.16006 7.04848 2.81067 7.04848 2.40748C7.04845 1.8285 6.57935 1.35938 6 1.35938C5.42102 1.35938 4.95155 1.8285 4.95155 2.40748C4.95155 2.81067 5.17896 3.16003 5.51259 3.33546C5.41043 4.13674 5.10867 5.17092 4.29054 5.53273C3.37207 5.9385 2.18702 5.49023 1.56703 4.20631C1.72561 4.04262 1.82339 3.81959 1.82339 3.57349C1.82339 3.07031 1.41506 2.66236 0.911883 2.66236C0.408328 2.66236 0 3.07031 0 3.57349C0 4.03711 0.34643 4.41907 0.793945 4.47694L1.8446 8.32252H10.1554L11.2061 4.47694C11.6539 4.41907 12 4.03711 12 3.57349Z" fill="#FFD15C"/>
                    <path d="M10.6644 9.96242C10.6644 10.337 10.3609 10.6407 9.98585 10.6407H2.01417C1.63952 10.6406 1.33594 10.337 1.33594 9.96242V9.90603C1.33594 9.53103 1.63952 9.22744 2.01417 9.22744H9.98585C10.3609 9.22744 10.6644 9.53103 10.6644 9.90603V9.96242Z" fill="#FFD15C"/>
                </svg>
                {{__('Самая популярная')}}
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/minecraft.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Minecraft</div>
                <div class="game-card-total-mods">30000+ {{__('модификаций')}}</div>
            </div>
            <div class="game-card-benefit">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_369_72)">
                        <path d="M10.672 4.917C10.546 4.661 10.285 4.5 10 4.5H6.854L7.328 0.845997C7.371 0.509997 7.183 0.184997 6.869 0.0559965C6.555 -0.0730035 6.193 0.0239965 5.988 0.293997L1.404 6.295C1.23 6.522 1.201 6.827 1.328 7.083C1.454 7.339 1.715 7.5 2 7.5H5.146L4.672 11.154C4.629 11.49 4.817 11.815 5.131 11.944C5.224 11.982 5.32 12.001 5.416 12.001C5.645 12.001 5.867 11.897 6.012 11.706L10.595 5.706C10.769 5.479 10.798 5.174 10.671 4.918L10.672 4.917Z" fill="#FFD15C"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_369_72">
                            <rect width="12" height="12" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                {{__('Больше всего модов')}}
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/ets2.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">ETS 2</div>
                <div class="game-card-total-mods">200+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/beamng.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">BeamNG.drive</div>
                <div class="game-card-total-mods">500+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/sims4.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">The Sims 4</div>
                <div class="game-card-total-mods">2500+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/terraria.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Terraria</div>
                <div class="game-card-total-mods">150+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/wukong.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Black Myth: Wukong</div>
                <div class="game-card-total-mods">50+ {{__('модификаций')}}</div>
            </div>
        </div>
        <div class="game-card-container">
            <img src="@/assets/images/games/stardew.png" class="game-card-image">
            <div class="game-card-text-container">
                <div class="game-card-title">Stardew Valley</div>
                <div class="game-card-total-mods">850+ {{__('модификаций')}}</div>
            </div>
        </div>

    </div>
</section>
</template>

<style scoped>
.slide-up {
    opacity: 0;
    transform: translateY(30px);
    animation: slideUp 0.8s ease-out forwards;
}

@keyframes slideUp {
    0% {
        opacity: 0;
        transform: translateY(30px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.games {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
}

.games-wrapper {
    display: flex;
    width: 100%;
    flex-direction: row;
    animation: scroll 40s linear infinite;
    will-change: transform;
}

@keyframes scroll {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(-100%);
    }
}

.game-card-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.game-card-text-container {
    display: flex;
    flex-direction: column;
}

.game-card-title {
    color: var(--text-primary);
    font-weight: 600;
}

.game-card-total-mods {
    font-weight: 500;
    color: var(--text-secondary);
}

.game-card-benefit {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #202020;
}

@media (min-width: 320px) {
    .games {
        height: 119.0625vw;
        gap: 5vw;
    }

    .games-wrapper {
        gap: 3.75vw;
    }

    .game-card-container {
        gap: 3.75vw;
    }

    .game-card-text-container {
        gap: 1.25vw;
    }

    .game-card-title {
        font-size: 4.6875vw;
    }

    .game-card-total-mods {
        font-size: 4.0625vw;
    }

    .game-card-benefit {
        padding: 1.25vw 3.125vw;
        border-radius: 7px;
        gap: 4px;
        font-size: 3.125vw;
    }

    .game-card-image {
        height: 59.6875vw;
        width: 45.9375vw;
    }

    h2 {
        text-align: left;
        font-size: 6.25vw;
        width: 90vw;
    }
}

@media (min-width: 464px) {
    .games {
        height: 359px;
        gap: 16px;
    }

    .games-wrapper {
        gap: 12px;
    }

    .game-card-container {
        gap: 12px;
    }

    .game-card-text-container {
        gap: 4px;
    }

    .game-card-title {
        font-size: 15px;
    }

    .game-card-total-mods {
        font-size: 13px;
    }

    .game-card-benefit {
        padding: 4px 8px;
        border-radius: 7px;
        gap: 4px;
        font-size: 10px;
    }

    .game-card-image {
        height: 191px;
        width: 147px;
    }

    h2 {
        text-align: center;
        width: auto;
        font-size: 20px;
    }
}

@media (min-width: 744px) {
    .games {
        height: 422px;
        gap: 20px;
    }

    .games-wrapper {
        gap: 12px;
    }

    .game-card-container {
        gap: 8px;
    }

    .game-card-text-container {
        gap: 4px;
    }

    .game-card-title {
        font-size: 16px;
    }

    .game-card-total-mods {
        font-size: 14px;
    }

    .game-card-benefit {
        padding: 4px 10px;
        border-radius: 7px;
        gap: 6px;
        font-size: 12px;
    }

    .game-card-image {
        height: 230px;
        width: 177px;
    }

    h2 {
        font-size: 26px;
    }
}

@media (min-width: 984px) {
    .games {
        height: 407px;
        gap: 24px;
    }

    .games-wrapper {
        gap: 12px;
    }

    .game-card-container {
        gap: 12px;
    }

    .game-card-text-container {
        gap: 4px;
    }

    .game-card-title {
        font-size: 16px;
    }

    .game-card-total-mods {
        font-size: 14px;
    }

    .game-card-benefit {
        padding: 4px 10px;
        border-radius: 7px;
        gap: 6px;
        font-size: 12px;
    }

    .game-card-image {
        height: 200px;
        width: 154px;
    }

    h2 {
        font-size: 28px;
    }
}

@media (min-width: 1248px) {
    .games {
        height: 545px;
        gap: 32px;
    }

    .games-wrapper {
        gap: 12px;
    }

    .game-card-container {
        gap: 18px;
    }

    .game-card-text-container {
        gap: 4px;
    }

    .game-card-title {
        font-size: 18px;
    }

    .game-card-total-mods {
        font-size: 16px;
    }

    .game-card-benefit {
        padding: 4px 10px;
        border-radius: 7px;
        gap: 6px;
        font-size: 13px;
    }

    .game-card-image {
        height: 258px;
        width: 198px;
    }

    h2 {
        font-size: 32px;
    }
}
</style>